module.exports = {"zh":"zh","Developer":"Developer","Type":"Type","TotalUnits":"Total Units","ExpTop":"Exp Top","Address":"Address","Location":"Location","Tenure":"Tenure","Country":"Country"}


//////////////////
// WEBPACK FOOTER
// ./src/assets/i18n/en.json
// module id = TKku
// module chunks = 18